function urlBase64ToUint8Array(base64String) {
  try {
    if (!base64String || typeof base64String !== 'string') {
      throw new Error('Invalid base64 string');
    }
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = atob(base64);
    return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
  } catch (error) {
    console.error('Error converting base64 to Uint8Array:', error);
    throw error;
  }
}

export async function requestPermission(browser) {
  if ( browser !== "pwa" ) return; 
  let api;
  if (window.location.href.includes("localhost")) api = "http://localhost:8000";
  else api = "https://v2.turbosify.com";

  /** 
   * 1. Get publicKey
   **/


  // const publicKey = "BOQWJGRcrngAiviDcWPiRl2_kWWejRA34GKrRHZwZlhJoBj9M_WsqZVMktHtpJAQjcgvwjy0HeqMmdaKzukqc8k";
  const publicKey = await fetch(`${api}/notification`).then(res => console.log(res.json()));
  console.log("Public Key:", publicKey);

const registration = await navigator.serviceWorker.register('/service-worker.js');
const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
    const response = await fetch('https://v2.turbosify.com/api/gpt/remind', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        subscription
      })
    });

  // if (browser === "mac") {
    // if (Notification.permission === "granted") alert("Từ vựng sắp được gửi tới cho bạn");
    // document.addEventListener("click", () => {
    //   Notification.requestPermission(); }, { once: true });
    // sendTestNotification();
  // }
  // else if (browser === "pwa"){
    // alert("Chúng tôi sẽ cập nhật định kì từ vựng cho bạn iu nhé");
    // Đăng ký service worker (nếu chưa)
    
    // console.log('🛠 Service worker registered:', registration);

    
    
    
    // console.log('📬 Định danh push subscription:', JSON.stringify(subscription));

    // Gửi subscription đến server
  //   const response = await fetch('https://v2.turbosify.com/api/gpt/remind', {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({
  //       subscription
  //     })
  //   });
  //   console.warn(response)
  // }

}

export function sendTestNotification() {
  if (!('Notification' in window)) {
    alert("Trình duyệt không hỗ trợ Notification API.");
    return;
  }

  if (Notification.permission === "granted") {
    navigator.serviceWorker.ready.then((reg) => {
      const sw = reg.active || navigator.serviceWorker.controller;
      if (sw) {
        sw.postMessage({
          title: "Thông báo thử nè 🎉",
          body: "Đây là thông báo test từ app bạn",
          icon: "/icon.png"
        });
        console.log("📬 Đã gửi yêu cầu thông báo sang service worker");
      } else {
        alert("⚠️ Không tìm thấy service worker đang active");
      }
    });
  } else if (Notification.permission === "default") {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") sendTestNotification();
      else alert("Bạn cần cấp quyền để nhận thông báo.");
    });
  } else {
    alert("Bạn đã từ chối quyền thông báo. Hãy thử bật hoặc liên lạc nhân viên hỗ trợ nhé");
  }
}

export function isPWA() {

  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent.toLowerCase();

  if (ua.includes("macintosh") && !ua.includes("chrome")) return false // Chrome
  if (!ua.includes("chrome") && !ua.includes("macintosh")) return false // Safari iOS
  if (window.navigator.standalone === true) return true

}